var staticEncodeURIComponent = encodeURIComponent

module.exports = staticEncodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticEncodeURIComponent.js
// module id = 618
// module chunks = 106